import React from 'react'
import PropTypes from 'prop-types'

import { ModalContainer } from './styles'

const Modal = ({
  isOpen,
  onRequestClose,
  style,
  contentlabel,
  children,
  transparent,
}) => (
  <ModalContainer
    isOpen={isOpen}
    onBackgroundClick={onRequestClose}
    style={style}
    contentlabel={contentlabel}
    backgroundProps={{
      style: {
        backgroundColor: transparent && 'transparent',
      },
    }}
  >
    {children}
  </ModalContainer>
)

Modal.propTypes = {
  isOpen: PropTypes.bool,
  transparent: PropTypes.bool,
  onRequestClose: PropTypes.func,
  style: PropTypes.shape({}),
  contentlabel: PropTypes.string,
  children: PropTypes.node.isRequired,
}

Modal.defaultProps = {
  isOpen: false,
  transparent: false,
  onRequestClose: null,
  style: null,
  contentlabel: null,
}

export default Modal
